"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiFacebookLogo, PiTwitterLogo, PiInstagramLogo, PiLinkedinLogo } from "react-icons/pi";

export default function CollegeFooter({
  content,
  onContentChange,
  isSelected,
}: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const socialLinks = content.socialLinks || [
    { platform: "facebook", url: "#" },
    { platform: "twitter", url: "#" },
    { platform: "linkedin", url: "#" },
    { platform: "instagram", url: "#" },
  ];

  const links = content.links || [
    "About", "Programs", "Admissions", "Campus", "Contact", "Privacy Policy", "Terms of Service"
  ];

  const socialIcons: Record<string, any> = {
    facebook: <PiFacebookLogo className="w-5 h-5" />,
    twitter: <PiTwitterLogo className="w-5 h-5" />,
    instagram: <PiInstagramLogo className="w-5 h-5" />,
    linkedin: <PiLinkedinLogo className="w-5 h-5" />,
  };

  return (
    <footer
      className={`py-12 bg-slate-900 text-slate-400 text-sm transition-all ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8 items-center border-b border-slate-800 pb-8">
        <div>
          <h3 className="text-xl font-bold text-white mb-2">
            <EditableText
              value={content.companyName || "COLLEGE"}
              onChange={(val) => onContentChange?.({ ...content, companyName: val })}
              as="span"
            />
          </h3>
          <p className="text-slate-500">Providing excellence in education and shaping future leaders.</p>
        </div>

        <div className="flex flex-wrap md:justify-end gap-4">
          {links.map((link: string, idx: number) => (
            <a key={idx} href={`#${link.toLowerCase()}`} className="hover:text-white transition-colors">
              {link}
            </a>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
        <p>
          <EditableText
            value={content.copyright || "© 2026 Instacks. All rights reserved."}
            onChange={(val) => onContentChange?.({ ...content, copyright: val })}
            as="span"
          />
        </p>

        <div className="flex gap-4">
          {socialLinks.map((social: any, idx: number) => (
            <a
              key={idx}
              href={social.url}
              className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center text-white hover:bg-amber-500 transition-colors"
            >
              {socialIcons[social.platform]}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
